var baseForOwn=require("./_baseForOwn"),createBaseEach=require("./_createBaseEach"),baseEach=createBaseEach(baseForOwn);module.exports=baseEach;